import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Footer from 'components/Footer2';
import { UserActions } from '../../../../store/actions/users';
import MainScreenReport from '../MainScreenReport/MainScreenReport';
import {
  orgTopics,
  screenType,
  orgPages,
  orgBotsSubPages,
} from '../MainScreenReport/index';

const INITIAL_CURRENT_PAGE_STATE_VALUE = {
  page: orgPages.BOTS,
  subPage: orgBotsSubPages.ORG_BOTS_NUMBER,
  // page: orgPages.DASHBOARD,
  // subPage: '',
};

/**
 * Org report main screen component, container for the entire screen
 *
 * @param {*} props
 * @returns
 */
const OrgReportMainScreen = (props) => {
  if (
    props.user?.selectedCompany?.claim?.name === 'User' ||
    props.user?.selectedCompany?.claim?.name === 'Viewer'
  ) {
    return <Redirect to="/home" />;
  }
  return (
    <>
      <MainScreenReport
        topics={orgTopics}
        reportScreenType={screenType.ORG}
        currentPageInitialState={INITIAL_CURRENT_PAGE_STATE_VALUE}
      />
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrgReportMainScreen)
);
